export const API_VERSION = 52;

export const SALESFORCE_API_ENDPOINT: {
  [key: string]: string;
} = {
  production: 'https://d.la1-core1.sfdc-yzvdd4.salesforceliveagent.com',
  preview: 'https://d.la1-c1cs-lo3.salesforceliveagent.com',
  development: 'https://d.la1-c1cs-lo3.salesforceliveagent.com',
};

export const AVAILABILITY_URL = '/chat/rest/Visitor/Availability';

export const ORG_ID = {
  production: '00DD0000000pnkQ',
  preview: '00D3G00000096mV',
  development: '00D3G00000096mV',
}; // ORG_ID

export const DEPLOYMENT_ID = '572D00000008Q3X';

export const BUTTON_IDS = {
  'de-AT': '5732p000000Csl1',
  'nl-BE': '5732p000000Csl2',
  'fr-BE': '5732p000000Csl3',
  'pt-BR': '5732p000000Csl4',
  'bg-BG': '5732p000000Csl5',
  'es-CL': '5732p000000Csl6',
  'es-CO': '5732p000000CslZ',
  'el-CY': '5732p000000Csl7',
  'cs-CZ': '5732p000000Csl8',
  'da-DK': '5732p000000Csl9',
  'et-EE': '5732p000000CslA',
  'fi-FI': '5732p000000CslB',
  'fr-FR': '5732p000000CslC',
  'de-DE': '5732p000000CslD',
  'el-GR': '5732p000000CslE',
  'hu-HU': '5732p000000CslF',
  'en-IE': '5732p000000CslG',
  'it-IT': '5732p000000CslH',
  'lv-LV': '5732p000000CslI',
  'lt-LT': '5732p000000CslJ',
  'fr-LU': '5732p000000CslK',
  'de-LU': '5732p000000CslL',
  'nl-NL': '5732p000000CslX',
  'nb-NO': '5732p000000CslN',
  'pl-PL': '5732p000000CslO',
  'pt-PT': '5732p000000CslP',
  'sk-SK': '5732p000000CslQ',
  'sl-SI': '5732p000000CslR',
  'es-ES': '5732p000000CslS',
  'sv-SE': '5732p000000CslT',
  'fr-CH': '5732p000000CslU',
  'de-CH': '5732p000000CslV',
  'it-CH': '5732p000000CslW',
  'en-GB': '5732p000000CslY',
  'en-US': '5732p000000CslZ',
  'es-US': '5732p000000CslZ',
};

export const CHAT_LOAD_STORAGE_KEY = 'loadChat';
export const CHAT_CONFIG_STORAGE_KEY = 'chatConfig';
export const CUSTOM_LIVE_AGENT = 'chatCustomConfig';
